import React from 'react';
import { Grid, Paper, Tabs, Tab, Box, Typography, IconButton } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { Api as ApiIcon } from '@mui/icons-material';
import ApiTester from 'components/api-tester';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import ClientsView from '../../features/ama_v2/components/clients-view';
import SnapshotsView from '../../features/ama_v2/components/snapshots-view';
import DashboardProcessorView from 'features/ama_v2/components/dashboard-processor-view';
import FileExplorerView from 'pages/file-explorer-view';


// import ClientsView from '../../features/ama/components/clients-view';
// import SnapshotsView from '../../features/ama/components/snapshots-view';
// import SchemaView from '../../features/ama/components/schema-view';
// import SchemaView from '../schema-view';
// import HelpView from '../../features/ama/components/help-view';

// const SILVER_DB = 'ama_common_silver_db_dev';
// const SILVER_TABLE = 'ama_silver_core';

interface TabPanelProps {
  children?: React.ReactNode;
  dir?: string;
  index: number;
  value: number;
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;
  return (
    <Box
      component="div"
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      sx={{ flex: 1, minHeight: 0, overflow: 'hidden' }}
      {...other}>

      {value === index && (
        <Box sx={{ p: 3, height: '100%', overflowY: 'auto' }}>
          {children}
        </Box>
      )}
    </Box>
  );
}

export default function AmaV2View() {

  const [apiTesterOpen, setApiTesterOpen] = React.useState(false);
  const theme = useTheme();
  const location = useLocation();
  const navigate = useNavigate();

  const tabs = [
    { label: 'Snapshots', path: '/ama-v2/snapshots', visible: true },
    { label: 'Clients', path: '/ama-v2/clients', visible: true },
    { label: 'Dashboard Processor', path: '/ama-v2/dashboard-processor', visible: true },
    { label: 'File Explorer', path: '/ama-v2/file-explorer', visible: true },
  ];
  const visibleTabs = tabs.filter((tab) => tab.visible);

  // Track current tab index; update via effect on location changes
  const [currentIndex, setCurrentIndex] = React.useState<number>(0);

  React.useEffect(() => {
    const idx = tabs.findIndex((tab) => tab.path === location.pathname);
    if (idx >= 0) {
      setCurrentIndex(idx);
    } else {
      // If path is unknown, redirect to first tab in an effect
      navigate(tabs[0].path, { replace: true });
      setCurrentIndex(0);
    }
  }, [location.pathname, navigate]);

  const visibleTabIndex = visibleTabs.findIndex((tab) => tab.path === tabs[currentIndex]?.path);

  const handleChange = (_event: React.SyntheticEvent, newVisibleIndex: number) => {
    const selectedTab = visibleTabs[newVisibleIndex];
    if (selectedTab) {
      const fullIndex = tabs.findIndex((tab) => tab.path === selectedTab.path);
      if (fullIndex >= 0) {
        setCurrentIndex(fullIndex);
      }
      navigate(selectedTab.path);
    }
  };

  // const handleChangeIndex = (index: number) => {
  //   setValue(index);
  // };

  return (
    <Grid item xs={12} sx={{ position: 'relative', height: '100%' }}>
      <Paper sx={{ p: 2, display: 'flex', flexDirection: 'column', height: '100%', minHeight: 0 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
          <Typography component="h2" variant="h6" color="primary" sx={{ flexGrow: 1 }}>
            Aid Matriculation Analysis: Snapshots
          </Typography>
          {/* API Test button (hide in prod if needed) */}
          <IconButton
            size="small"
            onClick={() => setApiTesterOpen(true)}
            title="API Tester"
            sx={{ color: theme.palette.primary.main }}
          >
            <ApiIcon fontSize="medium" />
          </IconButton>
        </Box>
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <Tabs value={visibleTabIndex >= 0 ? visibleTabIndex : false} onChange={handleChange} aria-label="AMA tabbed features">
            {visibleTabs.map((tab, index) => (
              <Tab key={tab.path} label={tab.label} component={Link} to={tab.path} {...a11yProps(index)} />
            ))}
            {/* <Tab label="Schema" component={Link} to={`${routes[2]}?db=${SILVER_DB}&table=${SILVER_TABLE}`} {...a11yProps(2)} />
            <Tab label="Help" component={Link} to={routes[3]} {...a11yProps(3)} /> */}
          </Tabs>
        </Box>        
        <CustomTabPanel value={currentIndex} index={0}>            
          <SnapshotsView/>
        </CustomTabPanel>
        <CustomTabPanel value={currentIndex} index={1}>
          <ClientsView/>
        </CustomTabPanel>
        <CustomTabPanel value={currentIndex} index={2}>
          <DashboardProcessorView/>
        </CustomTabPanel>
        <CustomTabPanel value={currentIndex} index={3}>
          <FileExplorerView isActive={currentIndex === 3} />
        </CustomTabPanel>

      </Paper>
      {/* API Tester Dialog */}
      <ApiTester
        open={apiTesterOpen}
        onClose={() => setApiTesterOpen(false)}
        baseUrl={process.env.REACT_APP_AMA_V2_API_URL || '/api'}
        title="AMA v2 API Tester"
      />
    </Grid>
  );
}

